import React from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";

function CheckboxSetting(props) {
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <FormControlLabel
              control={<Checkbox color={"primary"} disabled={!write} checked={!!((props.setting.value) ?? props.defaultChecked)}  />}
              label={props.label}
              onChange={(e) => {
                props.onChange(e.target.checked);
              }}
            />
            {props.children}
          </>
        );
      }}
    />
  );
}

export default CheckboxSetting;
